import { TodoContextMenu, TodoContextMenuState } from 'owa-todo-context-menu';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import type { ActionSource } from 'owa-todo-types';
import { getTodoCache } from '../store/todoCache';
import { getScenarioActions } from '../actions/getScenarioActions';

// TODO VSO 84849: handle the focus on delete in the agenda todo item
export default observer(function AgendaTodoContextMenu(props: {
    scenarioId: string;
    contextMenuState: TodoContextMenuState;
}) {
    const telemetryData = {
        actionSource: 'AgendaTodo' as ActionSource,
    };
    const { hideTodoContextMenu, updateTodoCurrentEditingId } = getScenarioActions(
        props.scenarioId
    );
    const callbacks = {
        onEdit: updateTodoCurrentEditingId,
        hideTodoContextMenu: hideTodoContextMenu,
    };
    const todo = getTodoCache(props.scenarioId).getTaskForLock(props.contextMenuState.todoId);
    return (
        todo && (
            <TodoContextMenu
                todo={todo}
                contextMenuState={props.contextMenuState}
                todoActionTelemetryData={telemetryData}
                callbacks={callbacks}
            />
        )
    );
});
